// ===================================================
// ФАЙЛ: frontend/src/pages/Error/MaintenancePage.jsx
// ===================================================
import React from 'react';
import MonumentErrorLayout from '../../components/Error/MonumentErrorLayout';
import { SUPPORT_EMAIL } from '../../utils/externalLinks';

const MaintenancePage = () => {
  return (
    <MonumentErrorLayout
      status="503"
      title="На обслуживании"
      description="Избу чуть подкрашиваем. Скоро снова откроем калитку."
      bgImageName="503"
    >
      <div className="mb-err-page__actions-row">
        <button type="button" className="mb-err-page__cta" onClick={() => window.location.reload()}>
          Обновить страницу
        </button>
        <a className="mb-err-page__cta mb-err-page__cta--secondary" href={`mailto:${SUPPORT_EMAIL}`}>
          Написать в поддержку
        </a>
      </div>
    </MonumentErrorLayout>
  );
};

export default MaintenancePage;
